const scriptActivation = true;
let activeCOD = true;
const CODCoupon = "COD5%";
let paymentInfoDiv = $('<div id="paymentInfoDiv"></div>');
let typePaymentDiv = $('<div id="typePaymentDiv"></div>');
let isDepositEnabled=null;
let modalShown=false;
 let badgeSaleSpan = $('.t4s-badge-sale');
    if (badgeSaleSpan.text().indexOf('100%') !== -1) {
      badgeSaleSpan.hide();
    }
badgeSaleSpan = null;
if (scriptActivation)$(document).ready(function () {
  console.log(`docReady start with : ${activeCOD} `);
  $se(linkCartBtns);
  $se(adjustSticky)
  $se(addTypePaymentDiv)
  $se(addPaymentDivs);
  $se(checkIfCouponApplied);
  $se(genCartElemnts);
  $se(groupColors);
  $se(updPriceinSticky);
  $se(forceImageInDrpDwn);
  $se(showThumbsOnDrp);
  $se(showProperDimensions);
  $se(hidePriceWhenZero);
  $se(notifyFor50Cm);
  $se(addBYBbadge);
  $se(readCoupon);
  $se(addDepthInfo);
  console.log("docReady finished");
})


function addDepthInfo() {
const infodiv = ` <div class="info-div"><i class="fa fa-info-circle"></i>Base Height excludes mattress heights..</div>`
  setInterval(function () {
let parent = $("body .pplr-depth");
if (parent.length > 0) {
  if($('.info-div').length <1)
    parent.append(infodiv); 
  }  
  },500);
}

function a() {
  $(".z_discount_input").on("change",function () {
      if($(this).val().length > 1) disCOD();
  })
}

function readCoupon() {
  $('.ppl-dis-apply').on('click', function() {
        // Finding the input element before the clicked button
        var inputBeforeButton = $(this).prevAll('input:first');

        // Logging the input value to the console before the button is clicked
        console.log('Input before click:', inputBeforeButton.val());
    });
}

function addBYBbadge(a=false) {
     $('body .t4s-product').each(function() {
  var firstLink = $(this).find('a').first().attr('href');
    var productImg = $(this).find('.t4s-product-info');
     var productOptions = $(this).data('product-options');
       
       if (productImg.length > 0 && productOptions && productOptions.isDefault === true && !productOptions.isSwatch) {
      const customDiv = `
  <div>
    <a href="${firstLink}" data-sort="sale,new,soldout,preOrder,custom" class="byb-badge">
      <span data-badge-sale="" class="">
        Customize Your Bed
      </span>
    </a>
  </div>
`;

// Use the variable in the prepend method
productImg.prepend(customDiv);
    }
  });
   if(!a) $('.t4s-loadmore-btn').on('click',function(){
     console.log("loaded more");
     addBYBbadge(true);
   });
}
function notifyFor50Cm() {
  setTimeout(function () {
    $('.pplr-swatch-element:contains("50cm")').on('click', function() {
      console.log("50Cm Trigger"+ $(this).text());
        showNotifModal('Prior to making a purchase of the 50cm Bed Base, please check the bed base height is suitable for your regular use, please measure your current bed base height.<br> Caculate total bed height by adding the mattress height to the selected bed base height for comparison.');
      });
    
  },1000);
}
function adjustSticky() {
   var $stickyDiv = $("#stickyATC");

  function handleScroll() {
    try{
    var offset = $(window).scrollTop();
    var cartBtnY = $("#addToCartBtn").offset().top;
      var windowheight = $(window).height();
    var viewSticky = offset > cartBtnY || offset < cartBtnY-windowheight;

   if (viewSticky){
     $stickyDiv.addClass("showSticky");
     $stickyDiv.removeClass("hideSticky");
   }
   else{
     $stickyDiv.addClass("hideSticky");
     $stickyDiv.removeClass("showSticky");
  
   } 
    }catch(e){};
  }
    

  $(window).scroll(handleScroll);

  // Initial check to handle the visibility based on the initial scroll position
  handleScroll();
  $('[data-cart-count]').on("change",function () {
    alert('count Changed');
  })

}
function addTypePaymentDiv() {
  
  typePaymentDiv.html(`
<div class="btn-group mcgp" role="group" ><input name="btnradio" type="radio" class="btn-check" id="codON" autocomplete="off" ${isDepositEnabled==true ? "checked":""} >
  <label class="btn btn-outline-primary mcg-btn" onclick="enCOD();" for="codON" >Pay Deposit</label>
  <input type="radio" class="btn-check" name="btnradio" id="codOFF" autocomplete="off"  ${isDepositEnabled==false? "checked":""}>
  <label class="btn btn-outline-primary mcg-btn" onclick="disCOD();" for="codOFF">Pay Full Amount</label>
</div>`);
}
function setPaymentInfoDiv(html) {
  paymentInfoDiv.html(html);
}

function addPaymentDivs(){
  
    $('.t4s-cart__tax').prepend(paymentInfoDiv);
    $('.t4s-cart__tax').prepend(typePaymentDiv);
    
  console.log('divs should be added by now'); 
}


function disCOD() {
  activeCOD=false;
   $(`.ppl_close_dis_tag[data-key="${CODCoupon}"]`).click();  
}
function enCOD() {
  var count = $('[data-tag]').filter(function() {
      return $(this).text().indexOf(CODCoupon) === -1;
  }).length;
   var numberOfChildren = $(`.ppl_close_dis_tag:not(:contains("${CODCoupon}"))`).length;
  if(numberOfChildren>0) {
    $(`.ppl_close_dis_tag:not(:contains("${CODCoupon}"))`).click();
  }
  
activeCOD=true;
setTimeout(function(){
  $('.ppl_dis_input').val(CODCoupon);
  $('.ppl_dis_apply').click(); 
},500)
  
}
function updateCartElmnts(){
  checkIfCouponApplied();
  let originalPrice = $('[data-original]').text();
  let discountPrice = $('[data-discount]').text();
  let finalPrice = $('[data-discounted]').text();
  let totalPrice = $('#cart_final_price').text();

  if (!totalPrice) totalPrice = $('[data-cart-prices]').text();
  if (!checkElemsData({ originalPrice, discountPrice, finalPrice, totalPrice })) return;

  let togHTML = "";
  if (activeCOD) {
    togHTML += `<div style="display:flex;justify-content:space-between;"></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Total price </span> <span>${originalPrice}</span></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Pay on Delivery of Goods </span> <span>${discountPrice.replace(/-/g, '')}</span></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span> <strong>Pay Now</strong> </span> <span><strong>${finalPrice}</strong></span></div>`;
    setPaymentInfoDiv(togHTML);
  } else if(!discountPrice) {
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span> <strong>Total price</strong> </span> <span><strong>${totalPrice.replace(/GBP/g, '') ?? originalPrice}</strong></span></div>`;
    setPaymentInfoDiv(togHTML);
  }
  else {
    rs = extractNumericValue(originalPrice) - extractNumericValue(discountPrice);
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Subtotal</span> <span>${originalPrice}</span></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span>Discount </span> <span>${discountPrice.replace(/-/g, '')}</span></div>`;
    togHTML += `<div style="display:flex;justify-content:space-between;"> <span> <strong>Total</strong> </span> <span><strong>£${rs.toFixed(2)}</strong></span></div>`;
    setPaymentInfoDiv(togHTML);
  }
//  console.log(`originalPrice :  ${originalPrice} -discountPrice ${discountPrice} - finalPrice ${finalPrice} - totalPrice ${totalPrice}`)
}
function genCartElemnts(){
  setInterval(function() {
    updateCartElmnts();
  }, 500);
}

function checkIfCouponApplied() {
   var numberOfChildren = $('.ppl_dis_tags_wrapper').children().length;
    let cpn = (`.ppl_tag_holder:has(:contains("${CODCoupon}"))`).length;
  var cpnlo = $(".ppl_dis_apply").children(".ppl_spinner-border").length;
  if ($(`.ppl_dis_tags_wrapper:has(:contains("${CODCoupon}"))`).length == 0 && activeCOD==true && numberOfChildren==0 && !cpnlo){ 
  enCOD();
  }
    else if ($(`.ppl_dis_tags_wrapper:has(:contains("${CODCoupon}"))`).length >0 && activeCOD==false || numberOfChildren>1) disCOD();
  if(activeCOD!=isDepositEnabled || isDepositEnabled==null) {
  isDepositEnabled = activeCOD;
  setTimeout(function () {
   addTypePaymentDiv(); 
  addPaymentDivs();  
  },500);
  
  }
}
             

function isCartPage() {
  if(window.location.pathname=="/cart") return true;
  return false;
}
function checkElemsData(data) {
   if(isCartPage) return true;
   let { originalPrice, discountPrice, finalPrice, totalPrice } = data;
  if (activeCOD) {
    if (originalPrice === "" || discountPrice === "" || finalPrice === "") {
      return false;
    }
  } else {
    if(totalPrice== ""){
      return false; 
    }
  }
  return true;
  
}
function areGroupsEqual(group1, group2) {
  if (!group1 || !group2) return false;
  if (group1 == "Linen-Copper" && group2 == "Linen") return true;
  const tolerance = 2;
  const errormargin = levenshteinDistance(group1.toLowerCase(), group2.toLowerCase());
  return errormargin <= tolerance;
}
function groupColors(notDefaultlist = false, retry = true) {
  const colorsList = $(notDefaultlist ? notDefaultlist : 'span[name="properties[Color]"]');
  const parentdiv = colorsList.first().closest('div');
  let listType;
  if (parentdiv.hasClass('img_thumb_dropdown')) listType = 'dropdown';
  else if (parentdiv.hasClass('img_thumb_big')) listType = 'bigThumb';
  if (!listType) {
    if (notDefaultlist) {
      if (retry) {
        setTimeout(function () {
          groupColors(false, false);
        }, 1500);
        return;
      }
      return ("No list found");
    } else {
      groupColors('span[name="properties[Colors]"]', retry);
    }
  } switch (listType) {
    case 'bigThumb':
      groupBigThumb(colorsList, notDefaultlist);
      break;
    default: console.warn("a List was found but type not defined");
  }

}
function groupBigThumb(colorsList, ndl = false) {

  var currentGroup = null;
  colorsList.each(function () {
    var element = $(this);
    var dataVal = element.attr('data-val');
    let elementGroup = dataVal.split(' ')[1] == "Velvet" ? dataVal.split(' ').slice(0, 2).join(' ') : dataVal.split(' ')[0];
    if (!areGroupsEqual(elementGroup, currentGroup)) {
      $(this).before(`<span style="z-index: 2; width:100%" class="pplr-swatch-element ">
            <h5 class="separator"> </h5> <h5 class="group_text"> <ins class=${ndl ? "wbg" : "dbg"}> ${elementGroup} </ins> </h5>
            </span>`);
      currentGroup = elementGroup;
    }
  });
}
function showProperDimensions() {
  var isSmall;
  var sizeSelection = "none";
  var depthSelection = "none";

  $('span[name="properties[Size]"]').click(function () {
    let bedSelected = $(this).text().toLowerCase();
    if (bedSelected.includes("small") || bedSelected.includes("single")) isSmall = true;
    else isSmall = false;
    const sizes = ["2ft6", "3ft", "4ft6", "4ft", "5ft", "6ft"];
    for (let i = 0; i < sizes.length; i++) {
      if (bedSelected.includes(sizes[i])) {
        sizeSelection = sizes[i];
        break;
      }
    }
 highlightDimTable(sizeSelection, "standard");
  });
    $('span[name="properties[S Depth]"], span[name="properties[S Type]"],  span[name="properties[L Type]"], span[name="properties[L Depth]"]').click(function () {
      let depthSelected = $(this).text().toLowerCase();
      
      if(depthSelected.includes("depth")){
      const depth = ["standard", "super", "deep"];
      for (let i = 0; i < depth.length; i++) {
        if (depthSelected.includes(depth[i])) {
          depthSelection = depth[i];
          break;
        }
      }
      }
      else if (!depthSelected.includes("ottoman")) return highlightDimTable(sizeSelection, "standard");
      highlightDimTable(sizeSelection, depthSelection);
    });
  }
function highlightDimTable(sz, dp) {
      let tableID;
      if (!dp || dp != "none") {
        $("#stdBedTblDiv").fadeOut();
        $("#xdeepBedTblDiv").fadeOut();
        $("#sdeepBedTblDiv").fadeOut();
      }
      switch (dp) {
        case "standard": tableID = "stdBedTbl"; break;
        case "super": tableID = "sdeepBedTbl"; break;
        case "deep": tableID = "xdeepBedTbl"; break;
      }
      $(`#${tableID}Div`).fadeIn();
      processTableRows(sz);
    }
  function processTableRows(sz, table = null) {
      $("tr").removeClass("highlightDimension dimDimension");
      var tableSelectors = ["#xdeepBedTbl", "#stdBedTbl", "#sdeepBedTbl"];
      tableSelectors.forEach(function (tableSelector) {
        if (table && table != tableSelector) return;
        $(`${tableSelector} tbody tr`).each(function () {
          var rowText = $(this).text().toLowerCase();

          if (rowText.includes(sz)) {
            if (sz !== "4ft") {
              $(this).addClass("highlightDimension");
            } else {
              if (sz === "4ft" && !rowText.includes("4ft6")) {
                $(this).addClass("highlightDimension");
              } else {
                $(this).addClass("dimDimension");
              }
            }
          } else {
            $(this).addClass("dimDimension");
          }
        });
      });
    }

function hidePriceWhenZero() {
      const priceObs = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.target.textContent.trim() == "£0.00") {
            $(mutation.target).fadeOut();
          } else {
            $(mutation.target).fadeIn();
          }
        });
      });
      const priceElements = document.getElementsByClassName('t4s-product-price');
      for (const element of priceElements) {
        priceObs.observe(element, { subtree: true, characterData: true, childList: true });
      }
      $('.t4s-cart_price').text($('.t4s-cart_price').text().replace('£0.00', ''));

  
  
    }
function showThumbsOnDrp() {
      $('.drpMat').on('click', updateDrpMenuBg);
      setTimeout(initDrpMenu, 500);
    }
function updateDrpMenuBg() {
      let parentDiv = $(this).closest('div');
      let menu = parentDiv.prevAll('span.pplr-selecter-selected.dropdowncolor').first();

      if (menu.length > 0) {
        menu.attr('style', `background-image: url("${$(this).data('image')}");`);
        //   menu.addClass("drpIMGadded");
      } else {
        //    menu.removeClass("drpIMGadded");
        menu.attr('style', `background-size: auto !important;`);
      }
    }
function initDrpMenu() {

      $('span.pplr-selecter-selected.dropdowncolor').each(function () {
        if ($(this).text().trim() === '') {
          $(this).text('-- Please select --');
        }
        let dataPsrcValue = findImgDataPsrc($(this));
        if (dataPsrcValue !== null) {
          $(this).attr('style', `background-image: url("${dataPsrcValue}");`);
          //   $(this).addClass("drpIMGadded");
        } else {
          $(this).attr('style', `background-size: auto !important;`);
          // $(this).removeClass("drpIMGadded");

        }
      });
    }
function findImgDataPsrc(spanElement) {
      let prevImg = spanElement.prevAll('img[data-psrc]').first();
      if (prevImg.length > 0) {
        return prevImg.attr('data-psrc');
      } else {
        return null;
      }
    }
function forceImageInDrpDwn__trigger() {

      let selectedSpans = $(".img_thumb_dropdown span[name^='properties']");
      selectedSpans.each(function () {
        let imageUrl = $(this).data('image');
        $(this).addClass("drpMat");
        $(this).attr('style', function (i, style) {
          return (style && style.endsWith('background-image: url("' + imageUrl + '") !important;')) ? style :
            (style || '') + 'background-image: url("' + imageUrl + '") !important;';
        });
      });

    }
function applyBg(item, addClass = null) {
      let options = $(`span[name="properties[${item}]"]`);
      options.each(function () {
        let imageUrl = $(this).data('image');
        if (addClass) $(this).addClass("drpMat");
        $(this).attr('style', function (i, style) {
          return (style && style.endsWith('background-image: url("' + imageUrl + '") !important;')) ? style :
            (style || '') + 'background-image: url("' + imageUrl + '") !important;';
        });
      });
    }
function forceImageInDrpDwn() {
      $('.pplr-selecter-selected.dropdowncolor').on('click', forceImageInDrpDwn__trigger);
      forceImageInDrpDwn__trigger();
        $('.dropdowncolor').each(function() {
      $(this).addClass("dropdownfixBg");      });
          }
function linkCartBtns() {

       $('#stickyAddBtn').on('click', function (e) {
         setTimeout(remSpinner,1500);
       });
       $('#addToCartBtn').on('click', function (e) {
         setTimeout(remSpinner,1500);
       });
      
    }
function remSpinner(){
  $(".pplr_adding").removeClass("pplr_adding");
}
function updPriceinSticky() {
      const stickyPrice = $('.stickyprice').first();
      const target = $('.t4s-product-price').get(0);
      if (!target) return;
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            price = $(mutation.target).text();
            $('.stickyprice').first().text($(mutation.target).text());
          //  $('#stickyProductTitle').text($('.t4s-product__title').first().text());
          
          }
        }
      });
      const config = { childList: true, subtree: true };
      observer.observe(target, config);
    }
function updCartCountinSticky() {
      const stickyPrice = $('.stickyprice').first();
      const target = $('[data-cart-count]').get(0);
      if (!target) return;
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            price = $(mutation.target).text();
            $('.stickyprice').first().text($(mutation.target).text());
          //  $('#stickyProductTitle').text($('.t4s-product__title').first().text());
          
          }
        }
      });
      const config = { childList: true, subtree: true };
      observer.observe(target, config);
    }
//this function is used to safely execute other options
function $se(func) {
  try {
    func();
    console.log((func.name || 'anonymous') + ' executed successfully');
  } catch (error) {
    console.error(`An error happened in ${func.name || 'anonymous'} function`);
    console.error(error);
  }
}


//helper 
function extractNumericValue(currencyString) {
    var match = currencyString.match(/[-+]?\d{1,3}(?:,\d{3})*(?:\.\d+)?/);
    return match ? parseFloat(match[0].replace(',', '')) : 0;
}
 function showNotifModal(message) {
   if(modalShown) return;
        $('.overlay').fadeIn();
        $('.modal').fadeIn();
        $('.modal .modal-body').html(message);
    $('.closeNotificationButton').on('click', function() {
        // Hide the overlay and modal
        $('.overlay, .modal').fadeOut();
      });
    modalShown = true;
      }
function levenshteinDistance(e,n){const t=e.length,l=n.length,r=Array.from({length:t+1},()=>Array(l+1).fill(0));
for(let f=0;f<=t;f++)for(let t=0;t<=l;t++)if(0===f)r[f][t]=t;else if(0===t)r[f][t]=f;else{const l=e[f-1]===n[t-1]?0:1;
r[f][t]=Math.min(r[f-1][t]+1,r[f][t-1]+1,r[f-1][t-1]+l)}return r[t][l]}